import * as Cesium from "cesium";
import { CesiumCursor } from "./CesiumCursor";
import { MarkerEntityType } from "./MarkerEntityType";

export const DEFAULT_PRIMARY_MARKER_SCALE = 0.32;

export const generatePrimaryMarker = (
  coordinates: number[],
  onClick: (id: number | string | undefined) => void,
  markerScale: number,
  markerColor: string,
  tooltipText: string,
): Cesium.Entity => {
  const color = /#[\da-f]+/i.exec(markerColor)?.[0] ?? "white";
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="200" height="200" viewBox="0 0 200 200">
      <defs>
        <style>
          .inner-circle, .outer-ring { fill: ${color}; }
          .outer-ring { opacity: 0.25; }
        </style>
      </defs>
      <circle class="outer-ring" cx="100" cy="100" r="100"/>
      <circle class="inner-circle" cx="100" cy="100" r="50"/>
    </svg>
  `;

  const img = new Image();
  img.src = "data:image/svg+xml;utf8," + encodeURIComponent(svg);

  return new Cesium.Entity({
    position: Cesium.Cartesian3.fromDegrees(coordinates[0], coordinates[1]),
    properties: {
      type: MarkerEntityType.PrimaryMarker,
      coordinates,
      onClick,
      tooltipText: tooltipText,
      tooltipPixelOffset: new Cesium.Cartesian2(0, -50),
      cursor: CesiumCursor.pointer,
    },
    billboard: {
      image: img as any,
      scale: markerScale ?? DEFAULT_PRIMARY_MARKER_SCALE,
      verticalOrigin: Cesium.VerticalOrigin.CENTER,
      heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
      disableDepthTestDistance: Number.POSITIVE_INFINITY,
    },
  });
};
